export const SPECS = {
  MinimumOrderStorefront: 'specs.stores.MinimumOrderStorefront',
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  PaypalUpdateShippingAndBilling: 'specs.stores.PaypalUpdateShippingAndBilling',
  showShippingMethodCashierExpressButton: 'specs.stores.ShowShippingMethodInApplePayModal',
  EcomPlatformCartAndCheckout: 'specs.stores.EcomPlatformCartAndCheckout',
  AddPickupPointsToCart: 'specs.stores.AddPickupPointsToCart',
  SecureCheckoutVelo: 'specs.stores.ShowHideSecureCheckoutVelo',
  SendUpdateBuyerNoteBiInCart: 'specs.stores.SendUpdateBuyerNoteBiInCart',
  PickupPointsBmPhase1: 'specs.stores.PickupPointsBmPhase1',
  VeloValidationOnCheckout: 'specs.stores.veloValidationOnCheckout',
  MultiCurrencyPOC: 'specs.stores.MultiCurrencyPOC',
  MoveCartBIEventsTo130: 'specs.stores.MoveCartBIEventsTo130',
  DisplayMixedCart: 'specs.stores.DisplayMixedCart',
  UseMixedCarts: 'specs.stores.UseMixedCarts',
  UseNewCheckoutInFastFlow: 'specs.stores.UseNewCheckoutInFastFlow',
  AllowFullPaymentOfflineWhenNoPaymentConnected: 'specs.stores.AllowFullPaymentOfflineWhenNoPaymentConnected',
  ShouldRoundItemsTotalWithAdditionalFees: 'specs.stores.ShouldRoundItemsTotalWithAdditionalFees',
} as const;
